import PolizaCards from "../components/PolizaCards"
import '../styles/poliza.css'

const PolizaScreen = () => {
    return (
        <>
            <div className="poliza__div">
                <h1><b>CONSULTA TU PÓLIZA</b></h1>
                <p>Estos son tus beneficios:</p>

                <PolizaCards />
            </div>
        </>
    )
}

export default PolizaScreen